<div class="bg-grey-100 text-grey-800 text-base font-semibold px-3 py-2.5">
  <span>{{ header }}</span>
</div>
<div class="px-3 py-2.5">
  <ng-content></ng-content>
</div>
